import { createIcon } from '../createIcon';

export const FilterAltIconConfig = {
  name: 'FilterAltIcon',
  height: 1024,
  width: 896,
  svgPath: 'M447,224 C206.86,224 111.23,170.5 111.23,141.5 C111.23,112.5 206.86,64 447,64 C687.14,64 782.77,111.8 782.77,141.5 C782.77,171.2 687.14,224 447,224 M447.5,0 C127.41,0 0,81.4 0,139.7 C0,176 27.68,194.9 66.65,240 L319.28,497.2 L319.28,796.7 C319.290625,805.064839 322.553964,813.097672 328.38,819.1 L501.26,995.9 C525.05,1017.7 535.14,1024 543.14,1024 C559.52,1023.9 575.14,1012.2 575.14,993 L575.14,497.1 L828.74,240 C838.44,228.8 895.000059,177 895.000059,139.7 C895.1,80 767.58,0 447.5,0',
  yOffset: 0,
  xOffset: 0,
};

export const FilterAltIcon = createIcon(FilterAltIconConfig);

export default FilterAltIcon;